type QueryParamValue = string | number | boolean | undefined | null;

export const appendQueryParam = (parameters: string, key: string, value: QueryParamValue): string => {
    if (value === undefined || value === null) {
        return parameters;
    }

    const prefix = parameters.length > 0 ? '&' : '';
    return `${parameters}${prefix}${key}=${value}`;
};

export const appendQueryParams = (
    parameters: string,
    params: Record<string, unknown>,
    fieldMap: Record<string, string>
): string => {
    return Object.entries(fieldMap).reduce((query, [paramKey, queryKey]) => {
        return appendQueryParam(query, queryKey, params[paramKey] as QueryParamValue);
    }, parameters);
};

export const appendPlatformParams = (parameters: string, platforms: unknown): string => {
    if (platforms === undefined || !platforms) {
        return parameters;
    }

    return (platforms as unknown[]).reduce<string>((query, item, index, items) => {
        const prefix = items.length > index ? '&' : '';
        return `${query}${prefix}Platforms=${item}`;
    }, parameters);
};

export const buildCampaignListQuery = (params: Record<string, unknown>): string => {
    let parameters = appendQueryParams('', params, {
        region: 'Region',
        name: 'Name',
        applicationScopeType: 'ApplicationScopeType',
        beginDate: 'BeginDate',
        endDate: 'EndDate',
        status: 'Status',
        assignee: 'Assignee',
        tag: 'Tag',
        isMatrix: 'IsMatrix',
        skipCount: 'SkipCount',
        maxResultCount: 'MaxResultCount',
        sortPropertyName: 'SortPropertyName',
        sortValue: 'SortValue',
    });

    parameters = appendPlatformParams(parameters, params.platforms);
    return parameters;
};

export const buildCampaignLogsQuery = (params: Record<string, unknown>): string => {
    let parameters = appendQueryParams('', params, {
        regionId: 'RegionId',
        campaignId: 'CampaignRuleId',
        email: 'Email',
        beginDate: 'BeginDate',
        sortPropertyName: 'SortPropertyName',
        sortValue: 'SortValue',
        skipCount: 'SkipCount',
        maxResultCount: 'MaxResultCount',
    });

    const endDate = params.endDate;
    if (endDate !== undefined && String(endDate).length > 0) {
        parameters = appendQueryParam(parameters, 'EndDate', endDate as QueryParamValue);
    }

    return parameters;
};
